module.exports = __webpack_public_path__ + "img/38884-011.a7e01748.jpg";